import { CLEAR_SITE_DATA } from '../application';
import { RECEIVE_TFR_TEMPLATES, REMOVE_TFR_TEMPLATE } from './actions';

const initialState = {
  tfrTemplates: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_TFR_TEMPLATES: {
      return {
        ...state,
        tfrTemplates: action.tfrTemplates,
      };
    }
    case REMOVE_TFR_TEMPLATE: {
      const templateIndex = state.tfrTemplates.findIndex(
        (template) => template.id === action.templateId
      );
      if (templateIndex !== -1) {
        return {
          ...state,
          tfrTemplates: [
            ...state.tfrTemplates.slice(0, templateIndex),
            ...state.tfrTemplates.slice(templateIndex + 1),
          ],
        };
      }
      return state;
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
